// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"3665518f","361":"5f4c9601","767":"6aca46ab"}[chunkId] + ".chunk.js";
};